export function ReviewersPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Reviewers</h1>
        <p className="text-gray-500 mt-1">Manage verification reviewers</p>
      </div>
      
      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
        <p className="text-gray-500">Reviewer management coming soon</p>
      </div>
    </div>
  )
}
